import { render, staticRenderFns } from "./ModalDownloadHistory.vue?vue&type=template&id=2a426522&"
import script from "./ModalDownloadHistory.vue?vue&type=script&lang=js&"
export * from "./ModalDownloadHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports